import { useEffect, useRef, useState } from "react";

import { MedplumClient } from "@medplum/core";
import { ClinicalImpression } from "@medplum/fhirtypes";

import {
  ClientNoteStatus,
  ClientNoteType,
  fetchClientNoteClinicalImpressions,
} from "@/clients/zod-schemas/client-note";

export function useClientNotes(
  clientId: string | undefined,
  medplum: MedplumClient,
  status: string,
  refresh: boolean,
  type: ClientNoteType,
) {
  const [clientNotes, setClientNotes] = useState<ClinicalImpression[]>([]);

  useEffect(() => {
    async function fetchNotes() {
      if (medplum && clientId) {
        const notes = await fetchClientNoteClinicalImpressions({
          medplum,
          clientId,
          status,
          type,
        });
        if (status === ClientNoteStatus.InProgress && type === "clientReminderNote") {
          setClientNotes(notes.slice(0, 8));
        } else {
          setClientNotes(notes);
        }
      }
    }
    fetchNotes();
  }, [medplum, clientId, status, refresh, type]);

  return clientNotes;
}

export function useOverflowCheck(activeNoteSummary: string | undefined, seeMore: boolean) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current;
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * 4; // 4 lines
      setIsOverflowing(element.scrollHeight > maxHeight);
    }
  }, [activeNoteSummary, seeMore]);

  return { isOverflowing, textRef };
}
